import React from 'react'
import { toast } from 'react-toastify'
import { Stack } from '@mui/system'
import { Button, Container, Typography, OutlinedInput, InputAdornment } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import SearchIcon from '@mui/icons-material/Search'
import { FullScreenLoader, ElxDataTable } from '../../components'
import axios from 'axios'
import {
  useGetDealerTypeListQuery,
  useUpdateDealerTypeDetailsMutation,
} from '../../redux/api/dealerType'
import { DealerTypeForm } from './DealerTypeForm'

export function DealerType() {
  const { isLoading, data, refetch } = useGetDealerTypeListQuery(null)
  const [updateStatus, { isSuccess, isError, isLoading: loading, error }] =
    useUpdateDealerTypeDetailsMutation()
  const [searchKey, setSearchKey] = React.useState<string>('')
  const [isVisible, setIsVisible] = React.useState(false)
  const [editableLeadType, setEditableLeadType] = React.useState<any>(null)

  React.useEffect(() => {
    if (isSuccess) {
      toast.success('Success!')
      refetch()
    }
    if (isError) {
      if (Array.isArray((error as any)?.data?.error)) {
        const errors = error as any
        errors?.data.error.forEach((el: any) =>
          toast.error(el?.message ?? 'Something Failed!', {
            position: 'top-right',
          }),
        )
      } else {
        toast.error((error as any)?.data?.message ?? 'Something Failed!', {
          position: 'top-right',
        })
      }
    }
  }, [loading])

  const handleEditable = (data: any) => {
    setEditableLeadType(data)
    setIsVisible(true)
  }

  const handleStatusUpdate = (data: any) => {
    const updatedData = {
      moduleIds: Array.isArray(data.moduleIds)
        ? data.moduleIds.map(String)
        : [String(data.moduleIds)],
      isActiveFlg: data.isActiveFlg === 1,
    }
    updateStatus(updatedData)
  }

  return (
    <Container maxWidth='xl' sx={{ paddingTop: 4, paddingBottom: 8 }}>
      <Stack direction='row' justifyContent='space-between' mb={2} mr={1}>
        <Typography variant='h4' color='#1E90FF'>
          Dealer Type
        </Typography>
        <Stack direction='row' alignItems='center'>
          <OutlinedInput
            placeholder='Search'
            onChange={(event) => setSearchKey(event.target.value)}
            endAdornment={
              <InputAdornment position='end'>
                <SearchIcon />
              </InputAdornment>
            }
            sx={{ marginRight: '20px' }}
          />
          <Button
            variant='outlined'
            sx={{ borderRadius: '20px', height: '40px', textDecoration: 'none' }}
            startIcon={<AddIcon />}
            onClick={() => {
              setIsVisible(true)
              setEditableLeadType(null)
            }}
            size='medium'
          >
            Create
          </Button>
        </Stack>
      </Stack>

      <ElxDataTable
        editable={true}
        checkbox={true}
        headLabelForId={'DealerType'}
        rows={data ?? []}
        searchKey={searchKey}
        editElxData={(data) => handleEditable(data)}
        disableElxData={handleStatusUpdate}
        perPage={5}
        gapPerPage={5}
        refetch={refetch}
      />

      <DealerTypeForm
        open={isVisible}
        onClose={() => setIsVisible(false)}
        leadType={editableLeadType}
        refetch={refetch}
      />
    </Container>
  )
}
